export function getBuildInfo(): { commitSha: string; buildTime: Date } {
  const commitSha = import.meta.env.VITE_COMMIT_SHA || 'dev';

  const rawBuildTime = import.meta.env.VITE_BUILD_TIME;
  const parsedBuildTime = rawBuildTime ? new Date(rawBuildTime) : new Date();
  const buildTime = Number.isNaN(parsedBuildTime.getTime()) ? new Date() : parsedBuildTime;

  return { commitSha, buildTime };
}
